import {deserialize} from "serializr";
import firebase from "firebase";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {PermissionsUserModel} from "@/modules/mpermissions/models/PermissionsUserModel";

export default {
    namespaced: true,
    state: {
        mAppPermissions: {"a":"b"},
        mUsersPermission: [],
        mUsers: [],
    },

    getters: {
        getUsers: state => {
            return state.mUsers;
        },
        getUsersPermission: state => {
            return state.mUsersPermission;
        },
        getAppPermission: state => {
            return state.mAppPermissions;
        },
    },
    mutations: {
        setUsers(state, values) {
            state.mUsers = values;
        },
        setUsersPermission(state, values) {
            state.mUsersPermission = values;
        },
        setAppPermission(state, values) {
            state.mAppPermissions = values;
        }
    },
    actions: {
        init({/*commit*/}) {
            console.info('permissions-store initialized.');
            let p = [
                //PermissionsStoreUtils.fethRegisteredApi(),
                PermissionsStoreUtils.fethApiPermission(),
                PermissionsStoreUtils.fethFrontendUsers(),
                PermissionsStoreUtils.fethAppPermission()
                //PermissionsStoreUtils.setEmptyAppPermision()
            ]

            // if (){
            //     PermissionsStoreUtils.fethApiPermission(),
            // }

            return Promise.all(p)
        },
        // setEmptyAppPermision({/*commit*/}){
        //     let db = firebase.database();
        //     let data = {}
        //     let appPermision = PermissionsStoreUtils.APP_PERMISSIONS()
        //     for (let p in appPermision){
        //         data[appPermision[p]] = false
        //     }
        //     let uid = firebase.auth().currentUser.uid
        //     return db.ref("/permission/" + uid)
        //         .set(data)
        //         .then(() => {})
        //         .catch((error) => {throw error})
        // },
        setUserAppPermission({/*commit*/}, data) {

            var trueValue = []
            var finalValue = []
            // get all api for keys
            for (var key in data.permissions){
                trueValue = trueValue.concat(PermissionsStoreUtils.getApiForKey(key))
            }

            trueValue.map(e => finalValue.push({id:e.toString(), enabled:true}))
            PermissionsStoreUtils.getAllApi().filter(e => !trueValue.includes(e)).map(e => finalValue.push({id:e.toString(), enabled:false}))


            if(!PermissionsStoreUtils.isDevelopment()){
                let index = finalValue.findIndex(e => e.id == 36)//createUserSnapshot (work only on development)
                if (index != -1) {
                    finalValue.splice(index, 1)
                }
            }

            let db = firebase.database();
            return db.ref("/permission/" + data.uid)
                .set(data.permissions)
                .then(() => {
                    return Promise.all([
                        PermissionsStoreUtils.setUserApiPermission(JSON.stringify([
                            {userId:data.uid, permissions:finalValue}
                            //{userId:data.uid, permissions:[{"id":"1","enabled":true}]}
                        ])),
                        PermissionsStoreUtils.fethAppPermission()
                    ])
                })
                .catch((error) => {
                    throw error
                })
        },
        fethAppPermission({commit}) {
            let db = firebase.database();
            return db.ref("/permission")
                .once("value")
                .then((snapshot) => {
                    let permissions = snapshot.val()
                    //console.log("setAppPermission: ",permissions)
                    if (permissions != null) {
                        commit("setAppPermission", permissions);
                    }
                }).catch((error) => {
                    throw error
                })
        },
        setUserApiPermission({/*commit*/}, data) {
            console.log("data: ", JSON.parse(data)[0].permissions)
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body: data
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setUserPermission', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            //let values = JSON.parse(data).map(v => deserialize(PermissionsUserModel, v));
                                            //console.log("getUsersPermission/: ", data)
                                            //commit("setUsersPermission", values);
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethApiPermission({commit}) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getUsersPermission', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            let values = JSON.parse(data).map(v => deserialize(PermissionsUserModel, v));
                                            //console.log("setUsersPermission: ", JSON.parse(data))
                                            commit("setUsersPermission", values);
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethFrontendUsers({commit}) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getFrontendUsers', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            let values = JSON.parse(data).map(v => deserialize(PermissionsUserModel, v));
                                            //console.log("setFrontendUsers: ", data)
                                            commit("setUsers", values);
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethRegisteredApi({/*commit*/}) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getRegisteredApi', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            //let values = JSON.parse(data).map(v => deserialize(PermissionsApiModel, v));
                                            console.log("RegisteredApi: ", JSON.parse(data))
                                            //commit("setRegisteredApi", values);
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

